import { OrdSearchI } from 'src/app/api/ord-search/ord-search.result.int';
import { OrdSearchQueryI } from 'src/app/api/ord-search/ord-search.query.int';
import { createActionGroup } from '@ngrx/store';
import { spxCreateApiActions } from '@softpak/components/spx-redux';

export const OrdSearchActions = createActionGroup({
  source: 'OrdSearch',
  events: {
    ...spxCreateApiActions<OrdSearchQueryI, OrdSearchI>(),
  },
});
